export const floatSafeAdd = (num1: number, num2: number) => {
    return ((num1 * 100) + (num2 * 100)) / 100
}
export const floatSafeSubstract = (num1: number, num2: number) => {
    return ((num1 * 100) - (num2 * 100)) / 100
}


// WEBPACK FOOTER //
// ./src/utils/number.ts